import React, { useState } from 'react';
import { ContainerFormForStatusFooter, ContainerMenu } from '../../../../components/Containers';
import HeaderTitle from '../../../../components/HeaderTitle';
import LineTableYear from '../../../../components/NovoSistema/LineTableYear';
import TableYear from '../../../../components/NovoSistema/TableYear';
import WrapperButtonsLinks from '../../../../components/NovoSistema/WrapperButtonsLinks';

export default function TemplateObrigacoesAcessorias() {
  const [year, setYear] = useState('21');
  return (
    <ContainerMenu>
      <ContainerFormForStatusFooter>
        <HeaderTitle text="Obrigações Acessórias Contábeis" linkIcon="/images/icons/information.svg" />
        <WrapperButtonsLinks year={year} setYear={setYear} />

        <TableYear year={year}>
          <LineTableYear
            title="SPED ECD Livro Razão – Escrituração Contábil Digital do Livro Razão"
            Dlink20="#"
            Rlink20="#"
            Dlink21="#"
            Rlink21="#"
          />
          <LineTableYear
            title="SPED ECD Livro Balancete – Escrituração Contábil Digital do Balancete de Verificação"
            Dlink20="#"
            Rlink20="#"
            Dlink21="#"
            Rlink21="#"
          />
          <LineTableYear
            title="SPED ECD Livro Registro de Inventário"
            Dlink20="#"
            Rlink20="#"
            Dlink21="#"
            Rlink21="#"
          />
          <LineTableYear
            title="SPED ECD Livro de Apuração do Lucro Real - LALUR"
            Dlink20="#"
            Rlink20="#"
            Dlink21="#"
            Rlink21="#"
          />
        </TableYear>
      </ContainerFormForStatusFooter>
    </ContainerMenu>
  );
}
